import Utils from './utils.js'
export default function() {
	let $container = $('.eshop-banner-section')
	let containerWidth = $container.outerWidth();
	let containerHeight = $container.outerHeight();
	let src = $('#eshop-banner-video').attr('video-url');

	let wrapperSize = Utils.CoverSize(16, 9, containerWidth, containerHeight);

	$container.find('.video-wrapper').css({width: wrapperSize[0], height: wrapperSize[1]});

	let player = new videojs('eshop-banner-video', {
		controls: true,
		poster: false,
		youtube: {
			controls: 1
		}
	});
	
	player.src({type: 'video/youtube', src: src});
}


// WEBPACK FOOTER //
// ./src/js/eshop.js